import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configApi } from '../../configApi';

const uploadDocument = async (_submissionId: string, itemId: string, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('name', file.name);
  formData.append('submission_item', itemId);

  const response = await configApi.post(
    `/api/title-submissions/items/${itemId}/documents/`,
    formData
  );
  return response.data;
};

export const useUploadTitleDocument = (submissionId: string, itemId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => uploadDocument(submissionId, itemId, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['title-submission', submissionId] });
      queryClient.invalidateQueries({ queryKey: ['title-submission-score-preview', submissionId] });
    },
  });
};
